module.exports = __webpack_public_path__ + "img/tree-06-a-trunk.d434540e.png";